import { ApiConfig } from "./ApiConfigs";
import store from "../redux/store";

// Callback for 403 NO_ACTIVE_PLAN - set by App/PlanGuard to redirect
let onNoActivePlan = null;
export const setOnNoActivePlan = (cb) => { onNoActivePlan = cb; };

export const ApiServices = async (method, url, data = {}, headers = {}) => {
    const token = store.getState().UserData?.userData?.token;
    const methodCustom = method.toUpperCase();
    const requestOptions = {
        method: methodCustom,
        headers: {
            ...headers,
            'Content-Type': "application/json",
            ...(token ? { 'Authorization': 'Bearer ' + token } : {}),
        },
    };
    if (methodCustom !== "GET" && methodCustom !== "HEAD") {
        requestOptions.body = JSON.stringify(data);
    }
    const res = await fetch(url, requestOptions);
    const json = await res.json();
    if (res.status === 403 && json?.code === "NO_ACTIVE_PLAN" && onNoActivePlan) {
        onNoActivePlan(json);
        throw new Error(json.message || "No active plan");
    }
    return json;
}

export const ApiServicesGraphQL = async (query, variables = {}) => {
    try {
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Access-Token": ApiConfig.ADMIN_TOKEN, // Shopify Admin API Token
            },
            body: JSON.stringify({ query, variables }),
        };

        const response = await fetch(ApiConfig.BASE_URL_GRAPHQL, requestOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const json = await response.json();
        return json;
    } catch (error) {
        console.error("GraphQL API Error:", error);
        return { error: error.message };
    }
};


export function uploadDocument(url, title) {
    let token = store.getState().UserData.userData.token
    const data = new FormData();
    data.append("file", url);
    data.append("document_type", title);
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + token
        },
        body: data,
        redirect: 'follow'
    };
    return fetch(ApiConfig.UPLOAD, requestOptions)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            return data;
        })
        .catch(error => {
            console.error('There was an error!', error);
            throw error;
        });
}
